import React, { useMemo } from 'react';
import { Field, useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import AccessContainers from '../../../components/access-containers/AccessContainers';
import useAccessAssistantsOptions from './useAccessAssistantsOptions';

function AIAssistantsContainer({ fieldName = 'assignedAssistants', disabled, search = '' }) {
  const assignedAssistants = useField(fieldName);

  const { accessAssistants, handleLoadMoreAssistants } = useAccessAssistantsOptions({ search });

  const isAccessAssistantsLoading = useSelector((state) => state.customers.isAccessAssistantsLoading);
  const totalAccessAssistants = useSelector((state) => state.customers.accessAssistantsTotal);

  const inactiveAssistants = useMemo(
    () =>
      accessAssistants.filter(
        (assistant) => !assignedAssistants.input.value.some((activeAssistant) => activeAssistant.id === assistant.id),
      ),
    [assignedAssistants.input.value, accessAssistants],
  );

  const handleAssignAssistant = (assistant) => {
    assignedAssistants.input.onChange([...assignedAssistants.input.value, assistant]);
  };

  const handleRemoveAssistant = ({ id }) => {
    assignedAssistants.input.onChange(assignedAssistants.input.value.filter((assistant) => assistant.id !== id));
  };

  return (
    <Field name={fieldName}>
      {({ input }) => (
        <AccessContainers
          onInactive={handleRemoveAssistant}
          onActive={handleAssignAssistant}
          inactive={inactiveAssistants}
          active={input.value}
          isLoading={isAccessAssistantsLoading}
          disabled={disabled}
          searchStr={search}
          onLoadMore={handleLoadMoreAssistants}
          totalElements={totalAccessAssistants}
          inactiveLoadedSize={accessAssistants.length}
        />
      )}
    </Field>
  );
}

export default AIAssistantsContainer;
